const initialState = {
    areaTree: [],
    agentTree: [],
    projectTree: [],
    currentTree:'',
    filter:'',
    currentNode:null
};
export const actionTypes = {
    LOAD_TREE: "LOAD_TREE",
    LOAD_TREE_RESPONSE: "LOAD_TREE_RESPONSE",
    SET_CURRENT_TREE:"SET_CURRENT_TREE",
    SET_CURRENT_NODE:"SET_CURRENT_NODE",
    RESET_DEV_TREE:"RESET_DEV_TREE"
};

export const actions = {
    load_tree: function (data) {
        return {
            type: actionTypes.LOAD_TREE,
            data
        }
    },
    set_current_tree: function (data) {
        return {
            type:actionTypes.SET_CURRENT_TREE,
            data
        }
    },
    set_current_node: function (data) {
        return {
            type:actionTypes.SET_CURRENT_NODE,
            data
        }
    },
    reset_dev_tree: function () {
        return {
            type:actionTypes.RESET_DEV_TREE
        }
    }
};

function loadData(tree, id, data) {
    if(tree.length === 0 || id === 0) {
        tree = data
        return tree
    }
    for(var i = 0;i< tree.length;i++) {
        if(tree[i].id === id) {
            tree[i].children = data
            return tree
        } else {
            if(tree[i].children && tree[i].children.length > 0) {
                tree[i].children = loadData(tree[i].children,id,data)
            }
        }
    }
    return tree
}

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.LOAD_TREE_RESPONSE:
            {
                console.log('LOAD_TREE_RESPONSE set new tree')
                if(action.data.type === 'areaTree') {
                    var [...tree] = state.areaTree
                    const newTree = loadData(tree, action.data.id, action.data.content)
                    let ftype = 'area';
                    if (action.data.content[0] && action.data.content[0].filtertype != '') {
                       ftype = action.data.content[0].filtertype;
                    }
                    return {
                        ...state, areaTree: newTree, currentTree: 'areaTree',filter:ftype,
                    }
                } else if(action.data.type === 'agentTree') {
                    var [...tree] = state.agentTree
                    const newTree = loadData(tree, action.data.id, action.data.content)
                    return {
                        ...state, agentTree: newTree, currentTree: 'agentTree', filter:'agent'
                    }
                } else if(action.data.type === 'projectTree') {
                    state.projectTree = [];
                    var [...tree] = state.projectTree
                    const newTree = loadData(tree, action.data.id, action.data.content)
                    return {
                        ...state, projectTree: newTree, currentTree: 'projectTree', filter:'project'
                    }
                }
            }
        case actionTypes.SET_CURRENT_TREE:{
            console.log('SET_CURRENT_TREE set currentTree tree '+ action.data)
            return {...state,currentTree:action.data, currentNode:null}
        }
        case actionTypes.SET_CURRENT_NODE:{
            return {...state,currentNode:action.data}
        }
        case actionTypes.RESET_DEV_TREE: {
            console.log('RESET_DEV_TREE logout set currentTree tree to null')
            return {...state,...{
                areaTree: [],
                agentTree: [],
                projectTree: [],
                currentTree:'',
                filter:'',
                currentNode:null
            }}
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/devManagerReducer.js